module.exports = __webpack_public_path__ + "img/nicetohave-product-design-10.813a1ab3.jpg";